import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useAccountLocaleT } from './useQuotesT';
import {
  getCountryConfig,
  getCountryFeatures,
  getRegistrationTypeConfig,
  normalizeCountryCode,
  type CountryFeatures,
  type SupportedCountryCode,
} from '../config/countryConfig';

export type ProCountryFeaturesState = {
  country: SupportedCountryCode;
  features: CountryFeatures;
  billingUi: boolean;
  boarding: boolean;
  efacturation: boolean;
  stripeConnect: boolean;
  boardingCerfa: boolean;
  registrationLabel: string;
  registrationPlaceholderKey: string;
  registrationType: string;
  registrationDigitLength: number;
};

/**
 * Features pays du pro connecté (défaut FR = pas de régression).
 */
export function useProCountryFeatures(): ProCountryFeaturesState {
  const { user } = useAuth();
  const tReg = useAccountLocaleT('registration');

  return useMemo(() => {
    const country = normalizeCountryCode(user?.country);
    const features = getCountryFeatures(country);
    const regType = getRegistrationTypeConfig(
      country,
      user?.business_registration_type
    );
    const cfg = getCountryConfig(country);
    return {
      country,
      features,
      billingUi: features.billingUi,
      boarding: features.boarding,
      efacturation: features.efacturation,
      stripeConnect: features.stripeConnect,
      boardingCerfa: features.boardingCerfa,
      registrationLabel: tReg(regType.labelKey),
      registrationPlaceholderKey: regType.placeholderKey,
      registrationType: regType.type || cfg.defaultRegistrationType,
      registrationDigitLength: regType.digitLength,
    };
  }, [
    user?.country,
    user?.invoice_language,
    user?.business_registration_type,
    tReg,
  ]);
}
